var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M44.2 21.6l-6.6 6.6c-1.2 1.2-3.2 1.2-4.4 0-1.2-1.2-1.2-3.2 0-4.4l16-16c.8-.8 2.2-.8 3.1 0l5.7 5.7s1.4 1.5 0 2.9L40.9 33.6c-3.6 2.7-8.5 2.1-11.4-.8l-.8-.8c-2.9-2.9-3.6-8.3-.6-11.3l7.7-7.7 5.9-5.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIndicator);
export default __webpack_public_path__ + "static/media/attachmentIndicator.9f5b7173854ac14d381183fac6689663.svg";
export { ForwardRef as ReactComponent };